import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpContext, HttpContextToken, HttpErrorResponse} from '@angular/common/http';
import {environment} from '@src/environments/environment';

export const BYPASS_LOADER = new HttpContextToken(() => false);

@Injectable({
  providedIn: 'root',
})
export class HttpClientService {
  constructor(private httpClient: HttpClient) {
  }

  /**
   * @param url Path (e.g. 'lmdb-admin/stores') or full path when using custom base.
   * @param options Request options.
   * @param skipLoader When true, bypass loader interceptor.
   * @param customBaseUrl When set, used as base URL instead of environment.restAPI (for multi-server / custom domain).
   */
  get(url: string, options: any, skipLoader?: boolean, customBaseUrl?: string): Observable<any> {
    if (skipLoader) {
      options = {
        ...options,
        context: new HttpContext().set(BYPASS_LOADER, true),
      };
    }
    const base = customBaseUrl != null && customBaseUrl !== ''
      ? customBaseUrl.replace(/\/$/, '')
      : environment.restAPI;
    const path = url.replace(/^\//, '');
    const fullUrl = base.endsWith('/') ? base + path : `${base}/${path}`;
    return this.httpClient.get(fullUrl, options);
  }

  put(
    url: string,
    body: any,
    options: any,
    skipLoader?: boolean,
  ): Observable<any> {
    if (skipLoader) {
      options = {
        ...options,
        context: new HttpContext().set(BYPASS_LOADER, true),
      };
    }
    return this.httpClient.put(environment.restAPI + url, body, options);
  }

  patch(
    url: string,
    body: any,
    options: any,
    skipLoader?: boolean,
  ): Observable<any> {
    if (skipLoader) {
      options = {
        ...options,
        context: new HttpContext().set(BYPASS_LOADER, true),
      };
    }
    return this.httpClient.put(environment.restAPI + url, body, options);
  }

  post(
    url: string,
    body: any,
    options: any,
    skipLoader?: boolean,
    customBaseUrl?: string,
  ): Observable<any> {
    if (skipLoader) {
      options = {
        ...options,
        context: new HttpContext().set(BYPASS_LOADER, true),
      };
    }
    const base = customBaseUrl != null && customBaseUrl !== ''
      ? customBaseUrl.replace(/\/$/, '')
      : environment.restAPI;
    const path = url.replace(/^\//, '');
    const fullUrl = base.endsWith('/') ? base + path : `${base}/${path}`;
    return this.httpClient.post(fullUrl, body, options);
  }

  delete(url: string, options: any, skipLoader?: boolean): Observable<any> {
    if (skipLoader) {
      options = {
        ...options,
        context: new HttpContext().set(BYPASS_LOADER, true),
      };
    }
    return this.httpClient.delete(environment.restAPI + url, options);
  }

  enquiry(body: any): Observable<any> {
    return this.httpClient.post(
      environment.restAPI + 'enquiry-service/create',
      //environment?.enquiryRestAPI,
      body,
      {},
    );
  }

  blobHttpErrorHandler(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();

    const obs = new Observable((observer: any) => {
      reader.onloadend = (e) => {
        observer.error({error: JSON.parse(reader.result + '')});
        observer.complete();
      };
    });
    reader.readAsText(err.error);
    return obs;
  }
}
